import { render } from "./login-form.vue?vue&type=template&id=5fc3df39&scoped=true"
import script from "./login-form.vue?vue&type=script&lang=js"
export * from "./login-form.vue?vue&type=script&lang=js"

import "./login-form.vue?vue&type=style&index=0&id=5fc3df39&lang=less&scoped=true"

import exportComponent from "/dev/shm/repo/piano-dp60u5626l1a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc3df39"]])

export default __exports__